import { all, call, put, takeLatest } from "redux-saga/effects";
import { updateProfileWorkBeforeApi } from "core/http/service/operationProcess";
import { getProfileWorkBeforeStart } from "../redux/getProfileWorkBefore";
import {
  updateProfileWorkBeforeFailed,
  updateProfileWorkBeforeStart,
  updateProfileWorkBeforeSuccess,
} from "../redux/updateProfileWorkBefore";
import { toast } from "react-toastify";

function* updateProfileWorkBefore(action) {
  const { callback, data } = action.payload;
  try {
    yield call(updateProfileWorkBeforeApi, data);
    callback?.();
    yield put({
      type: updateProfileWorkBeforeSuccess.type,
    });

    yield put({
      type: getProfileWorkBeforeStart.type,
    });
  } catch (error: any) {
    yield put({
      type: updateProfileWorkBeforeFailed.type,
    });
    toast.error(
      error?.response?.data?.message ||
        error.message ||
        "Có lỗi xảy ra, vui lòng thử lại sau"
    );
  }
}

function* watchUpdateProfileWorkBefore() {
  yield takeLatest(updateProfileWorkBeforeStart.type, updateProfileWorkBefore);
}

export default function* updateProfileWorkBeforeSaga() {
  yield all([watchUpdateProfileWorkBefore()]);
}
